import { initialize } from 'redux-form';

import { HACCP_TYPE_FORM_NAME, HACCP_FORM_NAME } from 'Common/FormEnum';
import { loading, handleErrorException, success } from 'State/actions';
import {
  ControlInfoHACCPTypeFormEnum,
  ControlInfoHACCPFormEnum,
} from 'Common/FieldEnum';

import * as types from './types';

export const writeHACCP = data => async (dispatch, getState, MPWWebApi) => {
  try {
    dispatch(loading(types.WRITE_HACCP_LOADING, true));

    const response = await MPWWebApi.postGenericInsertUpdate(
      'HACCP/WriteHACCP',
      data
    );

    dispatch(success(types.WRITE_HACCP_SUCCESS, response.data.Data));
    dispatch(
      initialize(HACCP_FORM_NAME, {
        [ControlInfoHACCPFormEnum.HACCP]: response.data.Data,
      })
    );
    return true;
  } catch (error) {
    dispatch(
      handleErrorException(error, types.WRITE_HACCP_ERROR, {
        Title: 'Error',
        Message: `Could not save HACCP.`,
      })
    );
    return false;
  } finally {
    dispatch(loading(types.WRITE_HACCP_LOADING, false));
  }
};

export const writeHACCPType = data => async (dispatch, getState, MPWWebApi) => {
  try {
    dispatch(loading(types.WRITE_HACCP_TYPE_LOADING, true));

    const response = await MPWWebApi.postGenericInsertUpdate(
      'HACCP/WriteHACCPType',
      data
    );

    dispatch(success(types.WRITE_HACCP_TYPE_SUCCESS, response.data.Data));

    dispatch(
      initialize(HACCP_TYPE_FORM_NAME, {
        [ControlInfoHACCPTypeFormEnum.HACCPType]: response.data.Data,
      })
    );
    return true;
  } catch (error) {
    dispatch(
      handleErrorException(error, types.WRITE_HACCP_TYPE_ERROR, {
        Title: 'Error',
        Message: `Could not save HACCP Type.`,
      })
    );
    return false;
  } finally {
    dispatch(loading(types.WRITE_HACCP_TYPE_LOADING, false));
  }
};

export const deleteHACCP = data => async (dispatch, getState, MPWWebApi) => {
  try {
    dispatch(loading(types.DELETE_HACCP_LOADING, true));

    const response = await MPWWebApi.postGenericInsertUpdate(
      'HACCP/WriteHACCP',
      data
    );

    dispatch(success(types.DELETE_HACCP_SUCCESS, response.data.Data));

    dispatch(
      initialize(HACCP_FORM_NAME, {
        [ControlInfoHACCPFormEnum.HACCP]: response.data.Data,
      })
    );
    return true;
  } catch (error) {
    dispatch(
      handleErrorException(error, types.DELETE_HACCP_ERROR, {
        Title: 'Error',
        Message: 'Could not delete HACCP.',
      })
    );
    return false;
  } finally {
    dispatch(loading(types.DELETE_HACCP_LOADING, false));
  }
};

export const deleteHACCPType = data => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    dispatch(loading(types.DELETE_HACCP_TYPE_LOADING, true));

    const response = await MPWWebApi.postGenericInsertUpdate(
      'HACCP/WriteHACCPType',
      data
    );

    dispatch(success(types.DELETE_HACCP_TYPE_SUCCESS, response.data.Data));

    dispatch(
      initialize(HACCP_TYPE_FORM_NAME, {
        [ControlInfoHACCPTypeFormEnum.HACCPType]: response.data.Data,
      })
    );
    return true;
  } catch (error) {
    dispatch(
      handleErrorException(error, types.DELETE_HACCP_TYPE_ERROR, {
        Title: 'Error',
        Message: `Could not delete HACCP Type.`,
      })
    );
    return false;
  } finally {
    dispatch(loading(types.DELETE_HACCP_TYPE_LOADING, false));
  }
};

export const getHACCP = () => async (dispatch, getState, MPWWebApi) => {
  try {
    dispatch(loading(types.GET_HACCP_LOADING, true));

    const response = await MPWWebApi.getGeneric('HACCP/GetHACCP');

    dispatch(
      initialize(HACCP_FORM_NAME, {
        [ControlInfoHACCPFormEnum.HACCP]: response.data.Data,
      })
    );
    dispatch(success(types.GET_HACCP_SUCCESS, response.data.Data));
  } catch (error) {
    dispatch(
      handleErrorException(error, types.GET_HACCP_ERROR, {
        Title: 'Error',
        Message: `Could not retrieve HACCP.`,
      })
    );
  } finally {
    dispatch(loading(types.GET_HACCP_LOADING, false));
  }
};

export const getHACCPType = () => async (dispatch, getState, MPWWebApi) => {
  try {
    dispatch(loading(types.GET_HACCP_TYPE_LOADING, false));

    const response = await MPWWebApi.getGeneric('HACCP/GetHACCPType');

    dispatch(
      initialize(HACCP_TYPE_FORM_NAME, {
        [ControlInfoHACCPTypeFormEnum.HACCPType]: response.data.Data,
      })
    );
    dispatch(success(types.GET_HACCP_TYPE_SUCCESS, response.data.Data));
  } catch (error) {
    dispatch(
      handleErrorException(error, types.GET_HACCP_TYPE_ERROR, {
        Title: 'Error',
        Message: `Could not retrieve HACCP Type.`,
      })
    );
  } finally {
    dispatch(loading(types.GET_HACCP_TYPE_LOADING, false));
  }
};

export const clearError = () => ({
  type: types.CLEAR_ERROR,
});



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/haccp/actions.js